<div class="container">
    <!-- For date disponibile-->
    <div class="row">
        <div class="col date">
            <h3 class="niceTitle"> 13/05/2021 </h3>
        </div>
    </div>
    <div class="row">
        <div class="col results">
            <!-- For ore disponibile-->
            <button type="button" class="btn btn-sm btn-outline-primary">20:35</button>    
        </div>
    </div>

    
</div>